module.exports = __webpack_public_path__ + "static/media/play.280fc343.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/play.svg
// module id = 1599
// module chunks = 0